import { Icon, Tooltip } from "@mui/material";

import Box from "../../Box";
import Button from "../../Button";
import Switch from "../../Switch";
import Typography from "../../Typography";
import Helpers from "../../../commons/helpers";
import useStrings from "../../../hooks/useStrings";

interface IProps {
    data: {
        icon: string;
        title: string;
        color: | "primary" | "secondary" | "info" | "success" | "warning" | "error" | "dark" | "light" | "white" | "default";
    };
    isDetail?: boolean;
    isOutlined?: boolean;
    hideTooltip?: boolean;
    valueSwitch?: boolean;
    isShowSwitchStatus?: boolean;
    onChangeSwitchStatus?: (value: boolean) => void
}

const StatusCell: React.FC<IProps> = (props: IProps) => {
    const strings = useStrings();
    const {
        data = { icon: "clear", color: "secondary", title: strings.Common.IN_ACTIVE },
        isDetail,

        hideTooltip,
        valueSwitch,
        isShowSwitchStatus,
        onChangeSwitchStatus,
    } = props;

    const renderStatusDetail = (props: { title: string, color: any, isOutlined?: boolean }) => {
        return (
            <Box
                variant="gradient"
                style={{
                    textAlign: "center",
                    padding: "4px 12px",
                    borderRadius: "8px",
                    border: props.isOutlined ? `1px ${props.color} solid` : "unset",
                }}
                bgColor={props.color}
            >
                <Typography
                    sx={{
                        lineHeight: 1.5,
                        fontSize: "11px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        letterSpacing: "0.02857em",
                        color: props.isOutlined ? props.color : "#ffffff",
                    }}
                >
                    {props.title}
                </Typography>
            </Box>
        )
    }

    const renderStatus = (props: {
        color: any;
        icon: string;
        title: string;
        valueSwitch: boolean;
        isOutlined?: boolean;
        hideTooltip?: boolean;
        isShowSwitchStatus?: boolean;
        onChangeSwitchStatus?: (value: boolean) => void
    }) => {
        return (
            <Box
                sx={{
                    display: "flex",
                    padding: "4px 12px",
                    alignItems: "center",
                    border: props.isOutlined ? `1px ${props.color} solid` : "unset",
                }}
            >
                <Box mr={1}>
                    {
                        props.isShowSwitchStatus
                            ? <Tooltip
                                title={strings.Common.CHANGE_STATUS}
                                open={(Helpers.isNullOrEmpty(props?.hideTooltip) || props?.hideTooltip === false) ? undefined : false}>
                                <Switch
                                    key="status"
                                    checked={props.valueSwitch}
                                    checkedColor={props.valueSwitch ? "success" : undefined}
                                    onChange={(event, checked) => {
                                        Helpers.isFunction(props.onChangeSwitchStatus) && props.onChangeSwitchStatus(checked);
                                    }}
                                />
                            </Tooltip>
                            : <Button disabled variant="outlined" color={props.color as any} iconOnly circular sx={{ padding: 0 }}>
                                <Icon sx={{ fontWeight: "bold", fontSize: "18px" }}>{props.icon}</Icon>
                            </Button>
                    }
                </Box>
                <Box>
                    <Typography variant="caption" fontWeight="medium" color={props.color} sx={{ lineHeight: 0 }}>
                        {props.title}
                    </Typography>
                </Box>
            </Box>
        );
    }

    if (!isDetail) {
        return renderStatus({
            icon: data.icon,
            color: data.color,
            title: data.title,
            hideTooltip: hideTooltip,
            valueSwitch: valueSwitch || false,
            isShowSwitchStatus: isShowSwitchStatus,
            onChangeSwitchStatus: onChangeSwitchStatus,
        });
    } else {
        return renderStatusDetail({ color: data.color, title: data.title })
    }
}

export default StatusCell;